<div class="card card-login">
  <div class="card-content">

    <able-loading [showLoading] = "showLoading"></able-loading>

    <div *ngIf="!showLoading">
      <div class="row">
        <div class="container-fluid">
          <div class="login-header text-center">
            <img [src]="this.logoPath" class="logo" alt="able+" title="able+" />
            <h3 *ngIf= 'emailConfirmed'>Email verified</h3>
            <h3 *ngIf='!emailConfirmed'>This link has expired</h3>
          </div>
        </div>
      </div>

      <div class="input-group" *ngIf= 'emailConfirmed'>
        <p>Your recovery email address was successfully verified.</p>
      </div>

    </div>

  </div>

  <div class="footer text-center">
    <p class="small">
      <a  *ngIf = "isUserAuthenticated" (click) = "redirectToAble()">
        <i class="material-icons">account_box</i> Log in
      </a>
      <a *ngIf = "!isUserAuthenticated" routerLink="/login" routerLinkActive="active">
        <i class="material-icons">account_box</i> Log in
      </a>
    </p>
  </div>

</div>
